import { Theme } from './symbols';

export const violetTheme: Theme = {
  name: 'violet',
  properties: {
    //violet 
    '--corecolour': '#39135e',
    '--corecolour1': '#39135e',
    '--corecolour-hover': '#2940b1',
    '--secondarycolour': '#0c93ac',
    '--secondarycolour-hover': '#113846',
    '--secondarycolour-mild': '#bd97e1',
    '--checkbox-indcolour': '#39135e',
    '--matformfield-colour': '#39135e',
    '--sidetoggle-gradient1': '#39135e',
    '--sidetoggle-gradient2': '#39135e',
    '--fab-gradient1': '#fdcc4b',
    '--fab-gradient2': '#f16c37',
    '--actionbutton-gradient1': 'red',
    '--actionbutton-gradient2': 'maroon',
    '--divider-gradient1': 'rgb(27, 142, 241)',
    '--divider-gradient2': 'rgb(27, 142, 241)',
    //Admin Gradient 
    '--admin-gradient1': '#39135e',
    '--admin-gradient2': '#39135e',
    '--btn-disabled-color': '#808080'
  }
};

export const tealTheme: Theme = {
  name: 'teal',
  properties: {
    //Teal 
    '--corecolour': '#036283',
    '--corecolour1': '#0178b7',
    '--corecolour-hover': '#113846',
    '--secondarycolour': '#2d91da',
    // '--secondarycolour-hover': '#113846',
    '--secondarycolour-hover': '#2a7bb6',
    '--secondarycolour-mild': '#77d5e4',
    '--checkbox-indcolour': '#56c9db',
    '--matformfield-colour': '#036283',
    '--sidetoggle-gradient1': '#036283',
    '--sidetoggle-gradient2': '#2d91da',
    '--fab-gradient1': '#56c9db',
    '--fab-gradient2': '#2d91da',
    '--actionbutton-gradient1': 'red',
    '--actionbutton-gradient2': 'maroon',
    '--divider-gradient1': 'rgb(27, 142, 241)',
    '--divider-gradient2': 'rgb(27, 142, 241)',
    //Admin Gradient 
    '--admin-gradient1': '#1a4655',
    '--admin-gradient2': '#0c93ac',
    '--btn-disabled-color': '#c8c3c3'
  }
};

export const defaultTheme: Theme = {
  name: 'default',
  properties: {
    //CrescoWorks
    // '--corecolour': '#283e4a',
    // '--corecolour1': '#283e4a',
    // '--corecolour-hover': '#1b2a32',
    // '--secondarycolour': '#283e4a',
    // '--secondarycolour-hover': '#1b2a32',
    // '--secondarycolour-mild': '#8baec1',
    // '--checkbox-indcolour': 'rgb(27, 142, 241)',
    // '--matformfield-colour': '#283e4a',
    // '--sidetoggle-gradient1': '#537793',
    // '--sidetoggle-gradient2': '#2d4553',
    // '--fab-gradient1': '#3498db',
    // '--fab-gradient2': '#154360',
    // '--actionbutton-gradient1': 'red',
    // '--actionbutton-gradient2': 'maroon',
    // '--divider-gradient1': 'rgb(27, 142, 241)',
    // '--divider-gradient2': 'rgb(27, 142, 241)',
    // //Admin Gradient
    // '--admin-gradient1': '#eed890',
    // '--admin-gradient2': '#deb221',
    // '--btn-disabled-color': '#808080'

    '--alignment': 'ltr',
    '--text-align': 'left',
    // '--padding': '0 8px 0 0',
    '--margin-right': '1%',
    '--right-radius': '2px',
    '--left-radius': '0px',
    '--border': '0px 1px solid rgba(0, 0, 0, 0.12) 0 0',
    '--border-right-width': '0px',
    '--border-left-width': '3px',

    
  }
};


export const blueTheme: Theme = {
  name: 'blue',
  properties: {
    //Blue
    '--corecolour': '#0b9bea',
    '--corecolour1': '#0b9bea',
    '--corecolour-hover': '#1b2a32',
    '--secondarycolour': '#0b9bea',
    '--secondarycolour-hover': '#1b2a32',
    '--secondarycolour-mild': '#8baec1',
    '--checkbox-indcolour': '#0b9bea',
    '--matformfield-colour': '#0b9bea',
    '--sidetoggle-gradient1': '#537793',
    '--sidetoggle-gradient2': '#2d4553',
    '--fab-gradient1': '#0b9bea',
    '--fab-gradient2': '#0b9bea',
    '--actionbutton-gradient1': 'red',
    '--actionbutton-gradient2': 'maroon',
    '--divider-gradient1': 'rgb(27, 142, 241)',
    '--divider-gradient2': 'rgb(27, 142, 241)',
    //Admin Gradient
    '--admin-gradient1': '#eed890',
    '--admin-gradient2': '#deb221',
    '--btn-disabled-color': '#808080'
  }
};
